<template>
  <div class="px-3 py-2">
    <b-row>
      <b-col>
        <h4 class="m-2">{{ $t("globals.sold_devices") }}:</h4>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <ulu-devices-sold-charts />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <ulu-all-devices-status />
      </b-col>
    </b-row>
    <hr />
    <b-row>
      <b-col>
        <ulu-all-devices-events />
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  components: {
    "ulu-devices-sold-charts": () =>
      import("@/components/dashboard/devices/DevicesSoldCharts.vue"),
    "ulu-all-devices-status": () =>
      import("@/components/dashboard/devices/DevicesStatus.vue"),
    "ulu-all-devices-events": () =>
      import("@/components/dashboard/devices/DevicesEvents.vue")
  }
};
</script>
